import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import * as fileSaver from 'file-saver';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-sucess',
  templateUrl: './sucess.component.html',
  styleUrls: ['./sucess.component.css']
})
export class SucessComponent implements OnInit {
  prop_id = '';
  payment_detail: any = [];
  download_url = '';
  
  constructor(private apiService: ApiService,
    private activatedRoute: ActivatedRoute, private appComponent : AppComponent) { }

  ngOnInit(): void {
    this.prop_id = this.activatedRoute.snapshot.queryParams['txnid'];

    this.Payment_detail();
    
  }


  Payment_detail(){
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`payment_receipt?transaction_id=${this.prop_id}`).subscribe(
      (res: any) => {
        if(res.success){
          this.payment_detail = res.data;
          console.log(this.payment_detail);
          this.download_url = res.receipt_url;
          this.appComponent.hideLoader();
        } else {
          this.appComponent.showMessageAlert('', 'error');
        this.appComponent.hideLoader();
        }
        
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
        this.appComponent.hideLoader();
      })
  }
  Download(){
    const _url =  this.download_url.split('/payment_receipts');

    fileSaver.saveAs(this.download_url, _url[1]);

  }

}
